/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BackToSignInAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function BackToSignInAction({
  children,
  viewPath = "/App/Auth/ResetPasswordSent/BackToSignInAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="large"
 block={true}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../SignIn'))}
 marginTop={dtSpaceM}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Back to Sign in"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}